var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00009 9.7996C8.50009 9.7996 8.92489 9.6248 9.27449 9.2752C9.62489 8.9248 9.80009 8.4996 9.80009 7.9996C9.80009 7.4996 9.62489 7.0748 9.27449 6.7252C8.92489 6.3748 8.50009 6.1996 8.00009 6.1996C7.50009 6.1996 7.07529 6.3748 6.72569 6.7252C6.37529 7.0748 6.20009 7.4996 6.20009 7.9996C6.20009 8.4996 6.37529 8.9248 6.72569 9.2752C7.07529 9.6248 7.50009 9.7996 8.00009 9.7996ZM8.00009 19.8004C5.40009 17.5004 3.45849 15.396 2.17529 13.4872C0.892088 11.5792 0.250488 9.8168 0.250488 8.2C0.250488 5.7664 1.02529 3.8332 2.57489 2.4004C4.12529 0.9668 5.93369 0.25 8.00009 0.25C10.0665 0.25 11.8749 0.9668 13.4253 2.4004C14.9749 3.8332 15.7497 5.7664 15.7497 8.2C15.7497 9.8168 15.1081 11.5792 13.8249 13.4872C12.5417 15.396 10.6001 17.5004 8.00009 19.8004Z",
    fill: "#A459FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.a642b4698bd878e3fb83545a3d2ba426.svg";
export { ForwardRef as ReactComponent };